
import { defineComponent, getCurrentInstance } from 'vue'
import ToolingPreviewNoResults from '../../tooling/tooling-preview-no-results.component.vue'

export default defineComponent({
  name: 'ToolReportingNoResults',
  components: {
    ToolingPreviewNoResults,
  },
  setup() {
    const {
      proxy: { $epb },
    } = getCurrentInstance()

    const messages = $epb.messages.insights.toolReporting

    return {
      messages,
    }
  },
})
